const defaultNames = {
  'processmaker-modeler-exclusive-gateway': 'Exclusive Gateway',
  'processmaker-modeler-inclusive-gateway': 'Inclusive Gateway',
  'processmaker-modeler-parallel-gateway': 'Parallel Gateway',
  'processmaker-modeler-event-based-gateway': 'Event Based Gateway',
};

export default defaultNames;
